import { Model } from '../parents/model';

export class CustomerGroupModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  get name() {
    return this.attributes[CustomerGroupModel.ATTR_NAME];
  }
}
